import type { LucideIcon } from 'lucide-react';

interface MetricBlockProps {
  icon: LucideIcon;
  label: string;
  value: string;
  unit?: string;
}

export function MetricBlock({ icon: Icon, label, value, unit }: MetricBlockProps) {
  return (
    <div className="metric-block">
      <div className="metric-label">
        <Icon size={17} />
        <span>{label}</span>
      </div>
      <div className="metric-value">
        <strong>{value}</strong>
        {unit && <span>{unit}</span>}
      </div>
    </div>
  );
}
